module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('footer', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Versions:")]), _vm._v(" Core: " + _vm._s(_vm.version.core) + " / Web: " + _vm._s(_vm.version.web) + " / "), _c('router-link', {
    attrs: {
      "to": "/version"
    }
  }, [_vm._v("Check")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("dpn.freeband.digital")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7584799a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 626
// module chunks = 1